import { EffectCallback, useEffect, useRef } from 'react';

/**
 * A side effect that runs once on mount. Uses a ref instead of deps for compatibility with React 18.
 */
export const useOnMountOnce = (effect: EffectCallback) => {
  const didRun = useRef(false);

  useEffect(() => {
    if (!didRun.current) {
      didRun.current = true;

      effect();
    }
    // eslint-disable-next-line react-x/exhaustive-deps -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
  }, []);
};
